import Vue from 'vue';
import Anchors from './plugins/vue-anchors-plugin';

Vue.use(Anchors);

const anchors = new Anchors();

export default anchors;



// WEBPACK FOOTER //
// ./src/anchors.js